var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"veui-button",class:{
    'veui-button-loading': _vm.loading,
    'veui-disabled': _vm.disabled
  }},'button',_vm.attrs,false),_vm.listeners),[(!_vm.loading)?[_vm._t("default")]:[_vm._t("loading",[_c('veui-icon',{attrs:{"name":_vm.icons.loading,"spin":""}}),_c('span',{staticClass:"veui-button-loading-text"},[_vm._t("default")],2)])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }